import React from 'react';
import ReactDOM from 'react-dom/client';
// import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './styles/index.css';
import $ from "jquery";
import Balancer from 'react-wrap-balancer'
import Popper from 'popper.js';
import axios from 'axios';
import { Container, Row, Col } from 'reactstrap';

import App from './scripts/global/App';
import reportWebVitals from './scripts/global/reportWebVitals';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
